export default __webpack_public_path__ + "static/media/karamia.197527a3.jpg";